export const dateFormatData = [
    "день/місяць/рік",
    "рік/місяць/день",
    "місяць/день/рік",
];

export const timeFormatData = [
    "12 годин",
    "24 години",
];

export const profileDropdownData = [
  { name: "POWON NET", path: "/settings/team" },
  { name: "Мій профіль", path: "/settings/profile" }
]